module.exports = __webpack_public_path__ + "img/sapphireAndRubin.d880519.png";